<!--
 * @Description: 管理员页面
 * @Author:wanqian
 * @Date: 2022-03-29 16:43:52
-->
<template>
	<div class="body">
		<el-row class="bk-search" style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
			<el-col :span="7" style="text-align: left">
				<span class="search-title">所属机构/医院：</span>
					<el-cascader size="small" style="width: 180px"  v-model="medicalInstObj" clearable filterable 
					placeholder="请输入/选择" :options="medicalInstTreeList" 
					:props="{ expandTrigger: 'hover', children: 'medicalInstList', label: 'name', value: 'id',}"
					@change="changeMedicalInst">
				</el-cascader>
			</el-col>
			<el-col :span="6" style="text-align: left">
				<span class="search-title">用户类型：</span>
				<el-select size="small" style="width: 180px" placeholder="请输入/选择" clearable 
					v-model="filterParams.adminType" filterable>
					<el-option v-for="(item, key) in adminTypeMap" :key="key" :label="item" :value="parseInt(key)">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="6" style="text-align: left">
				<span class="search-title">用户信息：</span>
				<el-input size="small" style="width: 200px" clearable placeholder="请输入姓名/手机号/账户名" 
					v-model="filterParams.nameMobileEmail">
				</el-input>
			</el-col>
			<el-col :span="5" style="text-align: right">
				<el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search" style="width: 80px;">
					搜 索
				</el-button>
				<el-button size="small" v-if="dataPvgList.includes('ADMIN_1_CREATE')" @click="handleAddAdmin" 
					type="primary" icon="el-icon-plus" style="width: 80px;">
					新 增
				</el-button>
			</el-col>
		</el-row>
		<div class="main-line"></div>
		<el-table style="margin: 20px 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable"
			:header-cell-style="{ 'text-align': 'left','background-color': '#EFF5FA'}" row-key="id"
      :tree-props="{ children: 'subadminList', hasChildren: 'hasChildren' }"
      :default-sort="{ prop: 'date', order: 'descending' }">
			<el-table-column label="所属机构/医院" align="left" min-width="20%">
				<template slot-scope="scope">
					<span v-if="scope.row.medicalInstList && scope.row.medicalInstList.length">
						<span v-for="(item, index) in scope.row.medicalInstList" :key="item.id">
							{{index == scope.row.medicalInstList.length-1 && item.name || (item.name + ',')}}
						</span>
					</span>
					<span v-else>- -</span>
				</template>
			</el-table-column>
			<el-table-column prop="typeText" label="用户类型" min-width="11%" align="left"></el-table-column>
			<el-table-column prop="name" label="姓名" min-width="8%" align="left"></el-table-column>
			<el-table-column label="手机号" min-width="11%" align="left">
				<template slot-scope="scope">
					<span>{{scope.row.mobile ? scope.row.mobile : '- -'}}</span>
				</template>
			</el-table-column>
			<el-table-column label="启用状态" min-width="8%" align="left">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" active-color="#13ce66" :active-value="1" :inactive-value="0" 
						:disabled="(scope.row.subType != 1 && !dataPvgList.includes('ADMIN_4_STATUS_CHG')) || (scope.row.subType == 1 && !dataPvgList.includes('ADMIN_8_SUB_STATUS_CHG'))"
						@change="handleStatusSwitch(scope.row, scope.row.id)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="createrName" label="创建人" min-width="8%" align="left">
				<template slot-scope="scope">
					{{scope.row.createrName ? scope.row.createrName : '- -'}}
				</template>
			</el-table-column>
			<el-table-column v-if="!isSdjk" label="微信消息" min-width="8%" align="left">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.useWxMsg" active-color="#13ce66" :active-value="1" :inactive-value="0" 
						:disabled="(scope.row.subType != 1 && dataPvgList.includes('ADMIN_2_UPDATE')) || (scope.row.subType == 1 && dataPvgList.includes('ADMIN_6_SUB_UPDATE'))"
						@change="handleWXmsgSwitch(scope.row, scope.row.id)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作" min-width="16%" align="left">
				<template slot-scope="scope">
					<div v-show="!isSdjk" style="display: inline-block;">
						<el-popover placement="bottom" width="210" trigger="click" popper-class="tag-popover">
							<img src="@/assets/usermng/icon-usermng-link.png" slot="reference" alt="" style="width: 15px; height: 10px; cursor: pointer;"/>
							<div style="margin: auto;">
								<div style="margin-left: 32px;">请微信扫码绑定微信号</div>
								<el-image :src="getQRcode(scope.row.id)" fit="contain" style="margin: 15px; width: 180px; height: 180px;"></el-image>
							</div>
						</el-popover>
						<el-divider direction="vertical"></el-divider>
					</div>
					<el-button @click="handleDetailClick(scope.row, scope.$index)" type="text" size="small">详情</el-button>
					<template v-if="((!scope.row.canHideInstAdminButton && scope.row.subType == 0 && dataPvgList.includes('ADMIN_3_DELETE'))) || (scope.row.subType == 1 && dataPvgList.includes('ADMIN_7_SUB_DELETE'))">
						<el-divider direction="vertical"></el-divider>
						<el-button @click="handleDeleteClick(scope.row, scope.$index)" type="text" size="small">删除</el-button>
					</template>
					<template v-if="canAddSubAdmin && scope.row.type == 2 && scope.row.subType == 0 && dataPvgList.includes('ADMIN_5_SUB_CREATE')">
						<el-divider direction="vertical"></el-divider>
						<el-button @click="handleAddAdmin(scope.row)" type="text" size="small">新增子管理员</el-button>
					</template>
				</template>
			</el-table-column>
		</el-table>
		<el-row class="foot-pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
				:current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
				layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
		</el-row>
		<!-- 管理员对话框 -->
		<admin-details :canUpdate="canUpdate" :visible="showDialog" :jumpType="jumpType" :adminId="adminId" :subType="subType" :instAdminId="instAdminId"
			:institutionId="instId" :hospitalId="hospitalId" :operate="operate" @close-dialog="closeDialog" />
	</div>
</template>

<script>
import Constant from '@/global/Constant.js'
import AdminDetails from './components/AdminDetails.vue'

export default {
	name: 'AdminList',

	components: {
		'admin-details':AdminDetails
	},

	data() {
		return {
			dataPvgList: [],    //在角色配置页面上的操作权限
			dataTable: [],
			medicalInstTreeList: [],
			filterParams: {
				adminType: '',
				medicalInstType: '',
				medicalInstId: '',
				page: 1,
				pageSize: this.commonConst.PAGE_SIZE,
			},
			pageSizes: this.commonConst.PAGE_SIZES,
			
			// 以下是管理员对话框使用
			showDialog: false,
			operate: null,
			adminId: null,//当前操作的用户ID
			subType: 0,//是否子管理员
			instAdminId: 0,//机管id

			instId: null,
			hospitalId: null,
			totalNumber: 0,
			adminTypeMap: {},
			medicalInstObj: [],
			jumpType: '',//新增机构/医院后显示新增管路员弹框类型，值为instAdd/hspAdd
			canAddSubAdmin: false,
			canUpdate: false,
			isSdjk: false
		}
	},

	computed: {
		tableWidth() {
			return 'width:' + (this.$root.contentWidth - 80) + 'px';
		},
	},

	methods: {
		async initView() {
			await this.getDataPvg4CurRole();
			this.canAddSubAdmin = this.dataPvgList.includes('ADMIN_5_SUB_CREATE')
			await this.getAdminFilterDo();
			await this.getAdminList();
		},

		getDataPvg4CurRole() {
			return new Promise((resolve) => {
				let requestData = {
					method: 'GET',
					url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
					param: {entityKey: 'ADMIN'},
				};
			this.vueRequest(requestData).then(result => {
				if (result != null) {
					this.dataPvgList = result.data;
					resolve();
				}
			})
		})
		},

		//获取过滤条件数据
		getAdminFilterDo() {
			return new Promise((resolve) => {
				this.appAxios("GET", Constant.URL_GET_ADMIN_FILTER_DO).then(result => {
					if (result != null) {
						this.initFilterData(result.data);
						resolve();
					}
				})
			})
		},

		initFilterData(filterObj) {
			this.rebuildMedicalInstTreeList(filterObj.medicalInstTreeList);
			this.adminTypeMap = filterObj.adminTypeMap;
			if (this.instId) {
				this.filterParams.adminType = 2;
				this.medicalInstObj = [this.filterParams.adminType, this.instId];
				this.filterParams.medicalInstType = this.medicalInstObj[0];
				this.filterParams.medicalInstId = this.medicalInstObj[1];
			} else if (this.hospitalId) {
				this.filterParams.adminType = 3;
				this.medicalInstObj = [this.filterParams.adminType, this.hospitalId];
				this.filterParams.medicalInstType = this.medicalInstObj[0];
				this.filterParams.medicalInstId = this.medicalInstObj[1];
			} else if (this.globalData.adminType == 2) {
				console.log(this.medicalInstTreeList, this.instId)
				this.medicalInstObj = [this.medicalInstTreeList[0].medicalInstType, this.medicalInstTreeList[0].medicalInstList[0].id];
				this.filterParams.medicalInstType = this.medicalInstObj[0];
				this.filterParams.medicalInstId = this.medicalInstObj[1];
      }
		},

		rebuildMedicalInstTreeList(list) {
			this.medicalInstTreeList = [];
			list.forEach(element => {
				//将一级结构新增name和id字段，保持el-cascader控件里props结构一致，否则显示有问题
				//将一级结构的id值与一级结构的medicalInstType相同，方便双向绑定直接获取
				element.name = element.typeName;
				if (!element.id) {
					element.id = element.medicalInstType;
				}
				this.medicalInstTreeList.push(element);
			});
		},

		//管理员接口调用
		getAdminList() {
			return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_PAGE_ADMINS,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
				this.vueRequest(requestData).then(result => {
					if (result != null) {
						this.dataTable = result.data;
						this.totalNumber = result.totalNumber;
						resolve();
					}
				})
			})
		},

		changeMedicalInst(_obj) {
			this.filterParams.medicalInstType = this.medicalInstObj[0];
			this.filterParams.medicalInstId = this.medicalInstObj[1];
		},

		getQRcode(id) {
			return this.commonUtil.fillUrlArgments(Constant.URL_GET_QR_CODE, id);
		},

		switchData(id) {
			let index = this.dataTable.findIndex(data => data.id === id)
			if (index != -1) return this.dataTable[index];
			
			let item = {}
			this.dataTable.map((item1, index1) => {
				if (!item1.subadminList) return true
				item1.subadminList.map((item2, index2) => {
					if (item2.id === id) {
						item = this.dataTable[index1].subadminList[index2]
						return false
					}
				})
			})
			console.log(item)
			return item
		},

		//启用状态改变
		handleStatusSwitch(row, id) {
			let item = this.switchData(id)
			item.status = row.status == 1 ? 0 : 1;
			console.log(row.status, '状态')
			let status = row.status == 1 ? "disable" : "enable";
			let strMessage = row.status == 1 ?'确认是否停用？' : '确认是否启用？';
			this.$confirm(strMessage, '提示', {
				confirmButtonText: '确 定',
				cancelButtonText: '取 消',
				type: 'warning'
			}).then(() => {
				this.queryStatusChange(id, status);
			});
		},

		handleWXmsgSwitch(row, id) {
			let item = this.switchData(id)
			item.useWxMsg = row.useWxMsg == 1 ? 0 : 1;
			let useWxMsg = row.useWxMsg == 0 ? true : false;
			let strMessage = row.useWxMsg == 0 ?'确认是否启用？' : '确认是否停用？';
			this.$confirm(strMessage, '提示', {
				confirmButtonText: '确 定',
				cancelButtonText: '取 消',
				type: 'warning'
			}).then(async() => {
				await this.updateWXmsgStatus(id, useWxMsg)
				this.getAdminList();
			});
		},

		updateWXmsgStatus(id, useWxMsg) {
			return new Promise((resolve, _reject) => {
				let params = {
			  	adminId: id,
			  	status: useWxMsg
			  };
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'PUT',
          url: Constant.URL_UPDATE_ADMIN_WXMSG,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };

				this.vueRequest(requestData).then(result => {
					resolve(result.data)
				});
			})
		},

		queryStatusChange(id, status) {
			let params = {
				adminId: id,
				status: status
			};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: Constant.URL_UPDATE_ADMINS_STATUS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
			this.vueRequest(requestData).then(_result => {
				this.getAdminList();
			});
		},

		getAdminMedicalInstsCountMsg(row) {
		  let params = {
        adminId: row.id
      };
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_ADMIN_MEDICAL_INSTS_COUNT_MSG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
			this.vueRequest(requestData).then(result => {
				if (result != null) {
					let strMessage = result.data && result.data.length ? (result.data + '确认删除？') 
						: (row.username + '账户将被删除，不可撤回，是否继续删除?');
					this.$confirm(strMessage, '提示', {
						confirmButtonText: '确 定',
						cancelButtonText: '取 消',
						type: 'warning'
					}).then(() => {
						this.deleteAdmin(row.id);
					});
				}
			})
		},

		deleteAdmin(id) {
			let params = {adminId: id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_ADMIN,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
			this.vueRequest(requestData).then(result => {
				if (result != null) {
					this.getAdminList();
				}
			})
		},

		//详情
		handleDetailClick(row) {
			this.subType = row.subType ? 1 : 0
			this.adminId = row.id;
			this.operate = 'details';
			this.showDialog = true;
			this.canUpdate = row.subType ? this.dataPvgList.includes('ADMIN_6_SUB_UPDATE') : this.dataPvgList.includes('ADMIN_2_UPDATE')
		},

		//删除
		handleDeleteClick(row, _index) {
			// type类型：1-主管理员 2-机构管理员 3-医院管理员  9-超管(系统保留，所有权限)
			if (row.type == 9) {
				this.$message({type: 'error',	message: '超级管理员不可删除!'});
				return;
			}
			// 人员是否停用状态？Y：提示：账户将被删除，不可撤回，是否继续删除?N：提示：请先关闭启用，再进行删除操作
			if (row.status == 1) {
				this.$confirm('请先关闭启用，再进行删除操作', '提示', {
					confirmButtonText: '确 定',
					cancelButtonText: '取 消',
					type: 'warning'
				})
				return;
			}
			// 人员是否有管辖机构
			this.getAdminMedicalInstsCountMsg(row);
		},
		
		//搜索功能
		handleQuery() {
			this.filterParams.page = 1;
			this.getAdminList();
		},

		//关闭dialog刷新数据
		closeDialog(refresh) {
			this.showDialog = false;
			this.adminId = 0
			//清除新增机构/医院路径带的数据
			this.jumpType = '';
			this.institutionId = '';
			this.hospitalId = '';
			if (refresh) {
				this.getAdminList();
			}
		},

		//以下是分页控件操作
		handleSizeChange(val) {
			this.filterParams.pageSize = val;
			this.getAdminList()
		},

		handleCurPage(curPage) {
			this.filterParams.page = curPage;
			this.getAdminList()
		},

		// 新增管理员
		handleAddAdmin(row) {
			if (row.id && !row.canAddSubadmin) return this.$message.error('最多只能添加25个子管理员！')
			this.subType = row.id ? 1 : 0
			this.instAdminId = row.id ? row.id : 0
			this.operate = 'add'
			this.adminId = 0;
			this.instId = row.medicalInstList ? row.medicalInstList[0].id : null
			this.showDialog = true
		},

		dateFormat(date) {
			return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
		},
	},

	mounted() {
		this.$emit("breadcrumb", {text1: '用户管理', text2: '管理员'});
		//跳转路径携带参数options：
		// type（必传）表示：新增机构/医院后跳转显示新增管理员弹框显示type,
		// type:1、机构新增跳转传instAdd，2、医院新增跳转传hspAdd 3、机构详情instDetails 4、医院详情hspDetails
		//institutionId(type为instAdd时必传)表示机构ID，机构列表-》更多-》管理员跳转必传
		//hospitalId(type为hspAdd时必传)标识医院ID，医院列表-》更多-》管理员跳转必传
		// adminId(type为instDetails/hspDetails时必传)管理员Id
		// subType(type为instDetails/hspDetails时选传)是否是机构子管理员
		if (this.$route.params.institutionId) {
			this.instId = this.$route.params.institutionId
		}
		if (this.$route.params.hospitalId) {
			this.hospitalId = this.$route.params.hospitalId;
		}
		if (this.$route.params.type) {
			this.jumpType = this.$route.params.type;
		}
		if (this.jumpType == 'instAdd' || this.jumpType == 'hspAdd') {
			this.operate = 'add'
			this.adminId = 0;
			this.showDialog = true
		} else if (this.jumpType == 'instDetails' || this.jumpType == 'hspDetails') {
			this.adminId = this.$route.params.adminId;
			this.subType = this.$route.params.subType;
			this.operate = 'details';
			this.showDialog = true;
		}
		this.initView();

		this.$nextTick(() => {
      if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') {
				this.isSdjk = true;
      } else {
        this.isSdjk = false;
      }
    });
	}
}
</script>

<style scoped>
.body {
	margin: 0;
	text-align: center;
	border: solid 0px;
}

.search-title {
	color: #657180;
	font-size: 14px;
}

.main-line {
	height: 10px;
	background-color: #f0f0f0;
}

.foot-pagination {
	margin-top: 20px;
	text-align: right;
	right: 35px;
	border: solid 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/usermng/AdminList.vue